$(document).on("click", "[id*='cancel_ticket_']" , function() {
  var ele = this;
  var ticket_id = $(ele).data("ticket-id");
  var credits_refund_in_credits_refund_option = $(ele).data("credits-refund-in-credits-refund-option");
  var credits_refund_in_money_refund_option = $(ele).data("credits-refund-in-money-refund-option");
  var amount_refund_in_money_refund_option = $(ele).data("amount-refund-in-money-refund-option");
  var can_cancel_in_credits = $(ele).data("can-cancel-in-credits");
  console.log(credits_refund_in_credits_refund_option);
  console.log(credits_refund_in_money_refund_option);
  console.log(amount_refund_in_money_refund_option);

  if(can_cancel_in_credits == false) {
    inputOptions= [ {  text: 'money', value: 'money', checked: true}  ]
    title = `Money Refund:  Credit Card-${amount_refund_in_money_refund_option} ` 
  }else if(amount_refund_in_money_refund_option > 0 ) {
    inputOptions= [ {  text: 'credits', value: 'credits', checked: true},  {  text: 'money', value: 'money'  }   ]
    title = `Credits Refund: Total ${credits_refund_in_credits_refund_option}.<br> Money Refund: Credits-${credits_refund_in_money_refund_option} & Credit Card-${amount_refund_in_money_refund_option} ` 
  } else{
    inputOptions= [ {  text: 'credits', value: 'credits', checked: true}  ]
    title = `Total ${credits_refund_in_credits_refund_option}  will be refunded as credits!`
  } 
  bootbox.prompt({
    title: title,
    inputType: 'radio',
    value: 'credits', /* value sets the initial checked item */
    inputOptions: inputOptions,
    callback: function (selected_option) {
      console.log(selected_option);
      if (selected_option != null){
        $.ajax({
          type: 'PUT',
          url: `/event_ticket/${ticket_id}/cancel`,
          data: {
            authenticity_token: $('meta[name="csrf-token"]')[0].content,
            selected_option: selected_option
          }        
        });
      }
    }
  });
});
